var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/deleteicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Delete",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 3.6363627,
    x2: 20,
    y2: 3.6363627,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0454545,0 L7.95454545,0 C7.20142989,0 6.59090909,0.610520639 6.59090909,1.36363601 L6.59090909,3.6363627 L13.4090909,3.6363627 L13.4090909,1.36363601 C13.4090909,0.610520639 12.7985701,0 12.0454545,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.95454545,
    y1: 15.2272688,
    x2: 7.95454545,
    y2: 8.40908875,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.0454545,
    y1: 15.2272688,
    x2: 12.0454545,
    y2: 8.40908875,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2363636,18.7454497 C16.1838968,19.4542339 15.5925391,20.0019341 14.8818182,20 L5.11818182,20 C4.40746088,20.0019341 3.81610324,19.4542339 3.76363636,18.7454497 L2.5,3.6363627 L17.5,3.6363627 L16.2363636,18.7454497 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.4d5a0debccf2ad19eeed0872eac5e450.svg";
export { ForwardRef as ReactComponent };